import moment from 'moment';
import colors from '../../../../styles/colors';

const DUE_SOON_DAYS = 3;

const DATE_STATUS_COLORS = {
  overdue: colors.shades.danger3,
  dueSoon: colors.shades.warning3,
  onTrack: colors.shades.success3,
  noDate: colors.shades.gamma2,
};

const getDateTimestampOrMax = (dateValue) => {
  const parsed = dateValue ? moment(dateValue.toDate()).valueOf() : Number.MAX_SAFE_INTEGER;
  return Number.isNaN(parsed) ? Number.MAX_SAFE_INTEGER : parsed;
};

const sortLeadsByDateField = (leads, fieldName) => {
  const comparator = (a, b) => getDateTimestampOrMax(a[fieldName]) - getDateTimestampOrMax(b[fieldName]);
  return [...leads].sort(comparator);
};

const getDateStatusColor = (dateValue) => {
  if (!dateValue) {
    return DATE_STATUS_COLORS.noDate;
  }
  const parsedDate = moment(dateValue.toDate());

  const now = moment();
  if (parsedDate.isBefore(now)) {
    return DATE_STATUS_COLORS.overdue;
  }

  const targetDate = parsedDate.clone();
  const dayDiff = targetDate.diff(now, 'days');

  if (dayDiff === 0) {
    return DATE_STATUS_COLORS.dueSoon;
  }

  return dayDiff <= DUE_SOON_DAYS ? DATE_STATUS_COLORS.dueSoon : DATE_STATUS_COLORS.onTrack;
};

export {
  getDateStatusColor,
  getDateTimestampOrMax,
  sortLeadsByDateField,
};
